var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import ExpandableTableRow from "./ExpandableTableRow";
import "./expandableTable.css";
var ExpandableTable = function (_a) {
    var columns = _a.columns, data = _a.data, childDataKey = _a.childDataKey, rowKey = _a.rowKey, rowColor = _a.rowColor, visibleOnInit = _a.visibleOnInit, hideCollapseExpandButtons = _a.hideCollapseExpandButtons;
    var _b = useState({
        timestamp: 0,
        collapse: undefined
    }), collapseAllEvent = _b[0], setCollapseAllEvent = _b[1];
    var rows = data.map(function (value) {
        var rowKeyValue = function () {
            if (rowKey) {
                return value[rowKey];
            }
            else {
                return "0" + Object.values(value).join();
            }
        };
        return (_jsx(ExpandableTableRow, { collapseAllEvent: collapseAllEvent, hideChildren: {
                timestamp: 0,
                collapse: undefined
            }, data: value, columns: columns, childDataKey: childDataKey || "child", childLevel: 0, rowKey: rowKey, rowColor: rowColor, visibleOnInit: visibleOnInit, expandParent: function () { } }, rowKeyValue()));
    });
    var renderHeaders = function () {
        return columns === null || columns === void 0 ? void 0 : columns.map(function (column) {
            return _jsx("th", { children: column.title }, column.title);
        });
    };
    var buttons;
    if (!hideCollapseExpandButtons) {
        buttons = (_jsxs("div", __assign({ className: "expandCollapseAllRow" }, { children: [_jsx("button", __assign({ className: "expandCollapseAll", onClick: function (e) {
                        setCollapseAllEvent({ timestamp: e.timeStamp, collapse: false });
                    } }, { children: "Expand All" }), void 0), _jsx("button", __assign({ className: "expandCollapseAll", onClick: function (e) {
                        setCollapseAllEvent({ timestamp: e.timeStamp, collapse: true });
                    } }, { children: "Collapse All" }), void 0)] }), void 0));
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { children: buttons }, void 0), _jsxs("table", { children: [_jsx("thead", { children: _jsx("tr", { children: renderHeaders() }, void 0) }, void 0), _jsx("tbody", { children: rows }, void 0)] }, void 0)] }, void 0));
};
export default ExpandableTable;
//# sourceMappingURL=ExpandableTable.js.map